import axios from 'axios';

function getUsaAveragesData() {
  const url = `${process.env.PUBLIC_URL}/data/usa.json`;

  return axios.get(url)
    .then(
      responce => {
        return responce.data;
      },
      error => {
        console.log('An error occured.', error);
        return [];
      }
    )
}

function getNationalData() {
  const url = `${process.env.PUBLIC_URL}/data/national.json`;

  return axios.get(url)
    .then(
      responce => {
        return responce.data;
      },
      error => {
        console.log('An error occured.', error);
        return [];
      }
    )
}

function getNationalPercentileData() {
  const url = `${process.env.PUBLIC_URL}/data/nationalPct.json`;

  return axios.get(url)
    .then(
      responce => {
        return responce.data;
      },
      error => {
        console.log('An error occured.', error);
        return [];
      }
    )
}

function getStateData(stateFips) {
  const url = `${process.env.PUBLIC_URL}/data/state_${stateFips}.json`;

  return axios.get(url)
    .then(
      responce => {
        return responce.data;
      },
      error => {
        console.log('An error occured.', error);
        return [];
      }
    )
}

function getStatePercentileData(stateFips) {
  const url = `${process.env.PUBLIC_URL}/data/statePct_${stateFips}.json`;

  return axios.get(url)
    .then(
      responce => {
        return responce.data;
      },
      error => {
        console.log('An error occured.', error);
        return [];
      }
    )
}

function getSearchData() {
  const url = `${process.env.PUBLIC_URL}/data/locations.json`;

  return axios.get(url)
    .then(
      responce => {
        return responce.data;
      },
      error => {
        console.log('An error occured.', error);
        return [];
      }
    )
}

function getDimensionsData() {
  const url = `${process.env.PUBLIC_URL}/data/dimensions.json`;

  return axios.get(url)
    .then(
      responce => {
        return responce.data;
      },
      error => {
        console.log('An error occured.', error);
        return [];
      }
    )
}

export default {
  getNationalData,
  getNationalPercentileData,
  getStateData,
  getStatePercentileData,
  getSearchData,
  getDimensionsData,
  getUsaAveragesData
}


// WEBPACK FOOTER //
// ./src/redux/services/data-service.js